import { render, staticRenderFns } from "./index.vue?vue&type=template&id=949c4cf6&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/one-stop-shop/one-stop-shop/one-stop-shop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('949c4cf6')) {
      api.createRecord('949c4cf6', component.options)
    } else {
      api.reload('949c4cf6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=949c4cf6&", function () {
      api.rerender('949c4cf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/wp-content/themes/global-theme/views/pages/productAside/Delivery/index.vue"
export default component.exports